var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full rounded-lg overflow-hidden relative text-white vote-result"},[_c('div',{staticClass:"w-full flex"},_vm._l((_vm.categories),function(category,i){return _c('div',{key:i,style:({
        width: `${category.percentage}%`,
        height: '3.5rem',
        'background-color': category.background
      })})}),0),_c('div',{staticClass:"w-full absolute top-0 left-0 flex"},_vm._l((_vm.categories),function(category,i){return _c('div',{key:i,staticClass:"vote",style:({
        flex: `1 ${100 - parseInt(category.percentage)} ${
          category.percentage
        }%`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '3.5rem'
      })},[(_vm.showLabel(i))?_c('span',{staticClass:"flex flex-col leading-tight",staticStyle:{"z-index":"+1"}},[_c('span',{staticClass:"text-chplus-xs uppercase"},[_vm._v(_vm._s(category.label))]),_c('span',{staticClass:"text-chplus-regular text-bold leading-none"},[_vm._v(" "+_vm._s(category.percentage.toFixed(1))),_c('span',{staticClass:"vote-result-percent"},[_vm._v("%")])]),_c('div',{staticClass:"text-chplus-xs whitespace-no-wrap",domProps:{"innerHTML":_vm._s(_vm.$tc('views.government.vote.vote_count', category.count))}})]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }